import React from 'react';
import isEqual from 'lodash.isequal';
import PropTypes from 'prop-types';
import { PROBE_DETAIL, ICON } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const ResponseBox = props => {
    const { selectedResponse, possibleResponses, correctResponse } = props;
    return (
        <div className="choice">
            {possibleResponses.map((response, index) => {
                const isChosen = isEqual(selectedResponse.response_id, response.response_id);
                return (
                    <div
                        key={generateReactKey(index)}
                        className={`example ${isChosen ? PROBE_DETAIL.CORRECT : ''}`}
                    >
                        {isEqual(correctResponse, response.response_id) && ICON.DONE}
                        {response.response_text}
                    </div>
                );
            })}
        </div>
    );
};

ResponseBox.defaultProps = {
    selectedResponse: {},
};

ResponseBox.propTypes = {
    possibleResponses: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedResponse: PropTypes.object,
    correctResponse: PropTypes.number.isRequired,
};

export default ResponseBox;
